import React from "react";
import { TaskSeo } from '../context/TaskSeo'
import { Din } from "../components/componentHeader/Header";
import { ExtendFragance } from "../components/componentExtens/ExtendFragance";
import { FooterAndButon } from "../components/componentFooter/Footer";


export function PageIn() {
  window.scrollTo(0, 0);
  return (
    <>
      <TaskSeo />
      <Din />
      <ExtendFragance />
      <FooterAndButon />
    </>
  );
}
